// src/pages/GlossaryPage.jsx
import React from 'react';
import Header from '../components/Header';
import GlossaryPanel from '../components/glossary/GlossaryPanel';
import usePageTracker from "../hooks/usePageTracker.js";

function GlossaryPage() {
  usePageTracker("glossary", "Repasando términos", null, "studying");

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      
      {/* 🚀 CORRECCIÓN MOBILE: Cambiamos padding a '1rem 0' 
          Esto da espacio arriba y abajo, pero 0 a los lados */}
      <main style={{ flex: 1, width: '100%', maxWidth: '100vw', padding: '1rem 0' }}>
        <GlossaryPanel />
      </main>
    </div>
  );
}

export default GlossaryPage;